// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"8f5a283f","133":"32874de8","182":"6f79614d"}[chunkId] + ".chunk.js";
};